<template>
  <div class="card-wrapper">
    <div class="card-title" v-if="meeting.expoMeetingCode">
      <div>
        <span>{{ meeting.meetingDate }}</span>
        <span>{{ meeting.meetingWeek }}</span>
        <span>{{ meeting.v_meetingTimeZone }}</span>
      </div>
    </div>
    <div class="card-body">
      <div class="card-timeline">
        <div class="card-timeline_tail">
          <div class="card-timeline_tail-start">
            <i class="fa fa-bullseye" />
            <span>{{ meeting.meetingBeginTime }}</span>
          </div>
          <div class="card-timeline_tail-end">
            <i class="fa fa-bullseye" />
            <span>{{ meeting.meetingEndTime }}</span>
          </div>
          <div style="padding-left: 8px;">
            <el-tag
              size="mini"
              class="my-2"
              :type="
                meeting.expoMeetingStatus === 'Y'
                  ? 'Y'
                  : meeting.expoMeetingStatus === 'E'
                  ? 'success'
                  : meeting.expoMeetingStatus === 'D'
                  ? 'danger'
                  : ''
              "
            >
              {{ meeting.v_expoMeetingStatus }}
            </el-tag>
            <TextLabel
              :label="$l('table_label_localTime') || 'Local Time'"
              :value="
                `${meeting.meetingLocalDate} ${meeting.meetingLocalBeginTime}`
              "
              label-bold
              :value-bold="false"
            />
          </div>
        </div>
        <div style="padding-left: 8px;">
          <TextLabel
            :label="$l('table_label_localTime') || 'Local Time'"
            :value="
              `${meeting.meetingLocalDate} ${meeting.meetingLocalEndTime}`
            "
            label-bold
            :value-bold="false"
          />
        </div>
      </div>
      <div class="card-context">
        <el-row :gutter="10">
          <el-col :md="11">
            <TextLabel
              :label="$l('list_label_custName') || 'Customer name'"
              :value="meeting.custName"
            />
          </el-col>
          <el-col :md="10">
            <TextLabel
              :label="$l('list_label_purposeOrIssue') || 'Purpose or Issue'"
              :value="meeting.purposeOrIssue"
            />
          </el-col>
          <el-col :md="3" style="display: flex;justify-content: flex-end;">
            <el-tag
              size="mini"
              effect="dark"
              :type="meeting.meetingImportantLevel"
            >
              {{ meeting.v_meetingImportantLevel }}
            </el-tag>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="mt-3">
            <TextLabel
              :label="$l('list_label_customerName') || 'Customer name'"
              :value="meeting.customerName"
            />
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :md="11" class="mt-3">
            <TextLabel
              :label="$l('list_label_attendanceNameList') || 'ABS attendance'"
              :value="convertsArrayString(meeting.attendanceNameList)"
            />
          </el-col>
          <el-col :md="13" class="mt-3">
            <TextLabel
              :label="$l('list_label_merchandiserNameList') || 'Merchandiser'"
              :value="convertsArrayString(meeting.merchandiserNameList)"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import TextLabel from './label.vue'
export default {
  props: { expoMeetingCode: { type: String, default: '' } },
  components: { TextLabel },
  data() {
    return {
      meeting: {},
      localTimeZone: '',
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.expoMeetingCode) return
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .expoMeetingDetailApi({
          expoMeetingCode: this.expoMeetingCode,
          localTimeZone,
        })
        .catch(() => null)
      if (!res) return
      this.meeting = res.body
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${
          offsetMinutes >= 0 ? '-' : '+'
        }${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    convertsArrayString(str) {
      if (!str) return ''
      const data = JSON.parse(str)
      return data.join(' / ')
    },
    openLinks() {},
    openDocs() {},
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tag--High {
    color: white;
    background-color: #fa5c7c;
    border: none;
  }
  .el-tag--Medium {
    color: white;
    background-color: #6c757d;
    border: none;
  }
  .el-tag--Low {
    color: white;
    background-color: #13cf97;
    border: none;
  }
  .el-tag--Y {
    color: #fa561f;
    background-color: #fff2e8;
    border-color: rgba($color: #fa561f, $alpha: 0.6);
  }
}
.card-wrapper {
  background-color: rgba(247, 247, 247, 1);
  padding: 10px 14px 14px;
  border-radius: 6px;
}
.card-wrapper .card-title {
  margin: 0;
  color: #6c757d;
  font-weight: 500;
  display: flex;
  margin-bottom: 0.5rem;
  div {
    span {
      margin-right: 1rem;
    }
    span:empty {
      display: none;
    }
  }
  div:first-child {
    margin-right: 3rem;
  }
}
.card-wrapper .card-body {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 15px 10px;
  display: flex;
  min-height: 200px;
}

.card-wrapper .card-body .card-timeline {
  width: 135px;
  padding-left: 8px;
  padding-bottom: 45px;
  .card-timeline_tail {
    border-left: 2px solid #e4e7ed;
    position: relative;
    padding: 16px 0;
    height: 100%;
    > div[class^='card-timeline_tail-'] {
      position: absolute;
      left: -8px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      span {
        font-size: 14px;
        line-height: 1;
        padding-left: 0.25rem;
      }
    }
    .card-timeline_tail-start {
      top: 0;
      i {
        color: #007bff;
      }
    }
    .card-timeline_tail-end {
      bottom: 0;
      i {
        color: #fa561f;
      }
    }
  }
}

.card-wrapper .card-body .card-context {
  flex: 1;
  .card-opt {
    display: flex;
    align-items: center;
    font-size: 23px;
    [class^='el-icon'] {
      font-size: 22px !important;
      color: #bbbbbb !important;
      font-weight: bold !important;
    }

    .opt-btn {
      margin-left: 100px;
    }
  }
}
</style>
